import { Component } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material';

@Component({
  selector: 'app-snackbar',
  template: '',
  styles: ['']
})
export class SnackbarComponent {

  // Config
  private configSuccess: MatSnackBarConfig = {
    politeness: undefined,
    announcementMessage: undefined,
    viewContainerRef: undefined,
    duration: 3000,
    panelClass: ['style-succes'],
    direction: undefined,
    data: undefined,
    horizontalPosition: 'center',
    verticalPosition: 'bottom',
  };

  private configError: MatSnackBarConfig = {
    politeness: undefined,
    announcementMessage: undefined,
    viewContainerRef: undefined,
    duration: 10000,
    panelClass: ['style-error'],
    direction: undefined,
    data: undefined,
    horizontalPosition: 'center',
    verticalPosition: 'bottom',
  };

  // Methods
  public snackbarSuccess(message: string) {
    this.snackBar.open(message, 'CLOSE', this.configSuccess);
  }

  public snackbarError(message: string) {
    this.snackBar.open(message, 'CLOSE', this.configError);
  }

  constructor(
    private snackBar: MatSnackBar,
  ) { }

}
